// App Reducer
import dotProp from "dot-prop-immutable";

import {
  TOGGLE_INDICATOR,
  UPDATE_COMMENT,
  UPSERT_SUGGESTED_TIP,
  DELETE_SUGGESTED_TIP,
  TOGGLE_SUGGESTED_TIP,
  TOGGLE_APPENDIX_TIP,
  RESET_ASSESSMENT
} from "./action";
import { RESET_APPS } from "@store/actions";

import initialState from "@store/initialState";

export default function sections(state = initialState.preTravel, action) {
  switch (action.type) {
    case TOGGLE_INDICATOR:
      return dotProp.toggle(
        state,
        `subsections.${action.activeSubStep}.risks.${action.riskIndex}.isRisk`
      );

    case UPDATE_COMMENT:
      return dotProp.set(
        state,
        `subsections.${action.activeSubStep}.comment`,
        action.comment
      );
    // Upsert a suggested tip
    case UPSERT_SUGGESTED_TIP: {
      const { stepIdx, tipIdx, tipText } = action.tipInfo;

      // A null tipIdx means that the suggested tip is new
      if (tipIdx === undefined) {
        const newSuggestedTip = {
          text: tipText,
          isChecked: true,
          isCustom: true
        };

        // Add the new suggested tip
        return dotProp.set(
          state,
          `subsections.${stepIdx}.suggestedTips`,
          list => [...list, newSuggestedTip]
        );
      }

      // Edit existing suggested tip
      return dotProp.set(
        state,
        `subsections.${stepIdx}.suggestedTips.${tipIdx}.text`,
        tipText
      );
    }
    // Delete a suggested tip
    case DELETE_SUGGESTED_TIP: {
      const { stepIdx, tipIdx } = action.tipInfo;

      return dotProp.delete(
        state,
        `subsections.${stepIdx}.suggestedTips.${tipIdx}`
      );
    }
    // Toggle a risk-specific suggested tip
    case TOGGLE_SUGGESTED_TIP: {
      const { stepIdx, tipIdx } = action.tipInfo;

      return dotProp.toggle(
        state,
        `subsections.${stepIdx}.suggestedTips.${tipIdx}.isChecked`
      );
    }
    // Toggle a risk-specific appendix tip
    case TOGGLE_APPENDIX_TIP: {
      const {
        stepIdx,
        appendixSectionKey,
        appendixSubsectionIdx,
        tipIdx
      } = action.tipInfo;

      // Get the selected tips in the current appendix (sub)section
      const currentSubsectionTips =
        state.subsections[stepIdx].checkedAppendixTips[appendixSectionKey][
          appendixSubsectionIdx
        ];

      // Add or remove the selected tip depending on whether it already existed in list
      const newCheckedList = !currentSubsectionTips.includes(tipIdx)
        ? [...currentSubsectionTips, tipIdx]
        : currentSubsectionTips.filter(tip => tip !== tipIdx);

      return dotProp.set(
        state,
        `subsections.${stepIdx}.checkedAppendixTips.${appendixSectionKey}.${appendixSubsectionIdx}`,
        newCheckedList
      );
    }

    case RESET_ASSESSMENT:
    case RESET_APPS:
      return initialState.preTravel;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pretravel/components/App/reducer.js